import {
  FormControlLabel as MUIFormControlLabel,
  Radio,
  SxProps,
} from '@mui/material';

import fonts from '@atom/styles/fonts';

const typographySx: SxProps = {
  fontSize: fonts.md,
};

export type RadioButtonProps = {
  value: string;
  label: any;
  disabled?: boolean;
  checked?: boolean;
  sx?: SxProps;
};

export const RadioButton = (props: RadioButtonProps) => {
  const { disabled = false, sx, ...data } = props;

  return (
    <MUIFormControlLabel
      slotProps={{ typography: { sx: typographySx } }}
      control={<Radio color="primary" disabled={disabled} />}
      sx={sx}
      {...data}
    />
  );
};

export default RadioButton;
